import type { default as PDFDocumentType } from 'pdfkit';
import PDFKit from 'pdfkit/js/pdfkit.standalone';

export class PDFDocument extends (PDFKit as typeof PDFDocumentType) {}

export interface Position {
  x: number;
  y: number;
}

export interface Bounds extends Position {
  width: number;
  height: number;
}

export type TextOptions = PDFKit.Mixins.TextOptions & {
  pos?: Position;
  size?: number | string;
  font?: string;
  color?: string;
};

export type TableOptions = Omit<Parameters<PDFDocument['table']>[0], 'data'> & {
  createRows?: () => Parameters<PDFKit.Mixins.PDFTableObject['row']>[0][];
};
